import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

const asyncActionTypes = createAsyncActionTypes([
  'GET_EHRS',
  'GET_EHR',
  'UPDATE_EHR',
  'CREATE_EHR',
  'DELETE_EHR',
  'GET_EHR_CONNECTORS',
  'CREATE_EHR_CONNECTOR',
  'DELETE_EHR_CONNECTOR',
  'GET_EHR_INGESTIONS',
  'CREATE_EHR_INGESTION',
  'GET_EHR_SCHEDULED_INGESTIONS',
  'CREATE_EHR_SCHEDULED_INGESTION',
  'DELETE_EHR_SCHEDULED_INGESTION',
]);

export default {
  ...asyncActionTypes,
};
